/**
 * LowStockBadge Component
 *
 * Small badge component showing "Low Stock" warning.
 * Used in table rows for items at or below reorder point.
 *
 * User Story: US-P6-001 - Inventory Management
 * Step 2: Inventory Items Management
 */

import { Badge } from '@/components/ui/badge'
import { AlertTriangle } from 'lucide-react'

/**
 * LowStockBadge Component
 *
 * @param {Object} props
 * @param {boolean} props.show - Whether to show the badge
 * @param {string} props.className - Additional CSS classes
 */
export default function LowStockBadge({ show = true, className = '' }) {
  if (!show) return null

  return (
    <Badge
      variant="outline"
      className={`bg-amber-50 text-amber-700 border-amber-200 text-xs gap-1 ${className}`}
    >
      <AlertTriangle className="h-3 w-3" />
      Low Stock
    </Badge>
  )
}
